/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicBookingSite } from '../models/PublicBookingSite';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BookingSitesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get public booking site
     * Get public booking site by public id
     * @param bookingSiteId
     * @returns PublicBookingSite
     * @throws ApiError
     */
    public getPublicBookingSite(
        bookingSiteId: string,
    ): CancelablePromise<PublicBookingSite> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/booking-sites/{bookingSiteId}',
            path: {
                'bookingSiteId': bookingSiteId,
            },
        });
    }
}
